import React from 'react';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import config from './config';
import Clinics from './pages/Clinics';
import Layout from '../../components/Layout';
import Networks from './pages/Networks';
import Files from './pages/Archivos';
import EditFiles from './pages/Archivos/Edit';

const path = config.PATH;
const name = config.NAME;

const routes = [
  {
    name,
    path,
    component: Layout,
    icon: <LocalHospitalIcon />,
    routes: [
      {
        name: 'Clínicas', path: `${path}/clinicas`, component: Clinics, exact: true,
      },
      {
        name: 'Redes', path: `${path}/redes`, component: Networks, exact: true,
      },
      // {
      //   name: 'Archivos', path: `${path}/archivos`, component: Files, exact: true,
      // },
      // {
      //   name: 'Editar archivo', path: `${path}/archivos/editar/:id`, component: EditFiles, exact: true,
      // },
    ],
  },
];

export default routes;
